<table class="table table-bordered">
  <thead>
    <tr>
      <th></th>
      @for (date of dates(); track date) {
        <th>
          {{ date | dateParse | dateFormat: 'ddd D' }}
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (item of map | keyvalue: sortByEmployeeRole; track item) {
      <tr>
        <td>
          <a routerLink="/employees/{{storeId()}}/{{item.key.employeePositionId.parseEmployeeId()}}/{{item.key.employeePositionId.parsePositionId()}}"
          class="employee-name">{{ item.key.name }}</a>
          <p class="employee-role">{{ item.key.role | enumParse }}</p>
          @for (availability of item.value; track availability) {
            <div>
              @if (availability.startTime) {
                <div
                  class="availability"
                  [style.left.px]="getAvailabilityLeftPixels(availability)"
                  [style.width.px]="getAvailabilityWidthPixels(availability)">
                  <div class="time-block-text">
                    {{ availability.startTime | timeParse | dateFormat: 'HH:mm' }}
                    <div class="horizontal-line"
                    [style.width.px]="getHorizontalLineWidthPixels(availability)"></div>
                    {{ availability.endTime | timeParse | dateFormat: 'HH:mm' }}
                  </div>
                </div>
              }
            </div>
          }
        </td>
        @for (date of dates(); track date) {
          <td></td>
        }
      </tr>
    }
  </tbody>
</table>
